import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

interface SidebarProps {
    onSidebarChange?: (width: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onSidebarChange }) => {
    const [isCatalogOpen, setCatalogOpen] = useState(false);
    const [isMovimientosOpen, setMovimientosOpen] = useState(false);
    const [isConsultasOpen, setConsultasOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [isHovered, setIsHovered] = useState(false);

    const nombreUsuario = localStorage.getItem('nombreUsuario') || 'Invitado';

    // Cargar estado del sidebar desde localStorage
    useEffect(() => {
        const savedCollapsedState = localStorage.getItem('sidebar_collapsed');
        if (savedCollapsedState !== null) {
            setIsCollapsed(JSON.parse(savedCollapsedState));
        } else {
            setIsCollapsed(true);
            localStorage.setItem('sidebar_collapsed', JSON.stringify(true));
        }
    }, []);

    // Calcular el ancho del sidebar y notificar cambios
    const sidebarWidth = isCollapsed ? (isHovered ? '280px' : '70px') : '280px';

    useEffect(() => {
        if (onSidebarChange) {
            onSidebarChange(sidebarWidth);
        }

        // Aplicar estilos globales para el layout
        const contentWrapper = document.querySelector('.content-wrapper') as HTMLElement;
        const mainHeader = document.querySelector('.main-header') as HTMLElement;

        if (contentWrapper) {
            contentWrapper.style.marginLeft = sidebarWidth;
            contentWrapper.style.transition = 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
        }

        if (mainHeader) {
            mainHeader.style.marginLeft = sidebarWidth;
            mainHeader.style.transition = 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
        }
    }, [sidebarWidth, onSidebarChange]);

    const handleMenuClick = useCallback((menuSetter: (value: boolean) => void, currentState: boolean) => {
        if (isCollapsed && !isHovered) {
            setIsHovered(true);
            setTimeout(() => {
                menuSetter(!currentState);
            }, 100);
        } else {
            menuSetter(!currentState);
        }
    }, [isCollapsed, isHovered]);

    const handleMouseEnter = useCallback(() => {
        if (isCollapsed) {
            setIsHovered(true);
        }
    }, [isCollapsed]);

    const handleMouseLeave = useCallback(() => {
        if (isCollapsed) {
            setIsHovered(false);
            setCatalogOpen(false);
            setMovimientosOpen(false);
            setConsultasOpen(false);
        }
    }, [isCollapsed]);

    const toggleSidebar = () => {
        const newCollapsedState = !isCollapsed;
        setIsCollapsed(newCollapsedState);
        localStorage.setItem('sidebar_collapsed', JSON.stringify(newCollapsedState));
    };

    return (
        <>
            <aside
                className="main-sidebar elevation-4"
                style={{
                    position: 'fixed',
                    height: '100vh',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    width: sidebarWidth,
                    zIndex: 1000,
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    background: 'linear-gradient(180deg, #1e293b 0%, #0f172a 100%)',
                    borderRight: '1px solid rgba(255, 255, 255, 0.1)',
                    boxShadow: '4px 0 20px rgba(0, 0, 0, 0.15)',
                    scrollbarWidth: isCollapsed && !isHovered ? 'none' : 'thin'
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
               
                

                {/* Brand Logo */}
                <Link to="/invinicio" className="brand-link" style={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    padding: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    textDecoration: 'none',
                    color: 'white'
                }}>
                    <img
                        src="dist/img/bbtt2.png"
                        alt="Babatsa Logo"
                        className="brand-image img-circle elevation-3"
                        style={{
                            opacity: 1,
                            transition: 'all 0.3s ease',
                            width: '30px',
                            height: '30px',
                            border: '2px solid rgba(255, 255, 255, 0.2)',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                        }}
                    />
                    <span
                        className="brand-text font-weight-bold"
                        style={{
                            opacity: isCollapsed && !isHovered ? 0 : 1,
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            marginLeft: isCollapsed && !isHovered ? '-200px' : '12px',
                            fontSize: '1.2rem',
                            fontWeight: '700',
                            color: 'white',
                            textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                        }}
                    >
                       🔩 Babatsa
                    </span>
                </Link>

                {/* Sidebar */}
                <div className="sidebar" style={{
                    padding: isCollapsed && !isHovered ? '1.5rem 0.5rem' : '1.5rem',
                    transition: 'padding 0.3s ease'
                }}>
                   {/* Sidebar user panel */}
<div className="user-panel mt-3 pb-3 mb-3 d-flex" style={{
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    background: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '12px',
    padding: isCollapsed && !isHovered ? '0.8rem 0' : '1rem',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    // Centrar contenido cuando está comprimido
    justifyContent: isCollapsed && !isHovered ? 'center' : 'flex-start',
    alignItems: 'center',
    minHeight: isCollapsed && !isHovered ? '50px' : 'auto',
    width: '100%'
}}>
    <div className="image" style={{
        // Centrar la imagen cuando está comprimido
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: isCollapsed && !isHovered ? '100%' : 'auto',
        margin: isCollapsed && !isHovered ? '0' : '0'
    }}>
        <img
            src="dist/img/Cappuccino-Assassino.webp"
            className="img-circle elevation-2"
            alt="User"
            style={{
                transition: 'all 0.3s ease',
                width: '30px',
                height: '30px',
                border: '2px solid rgba(59, 130, 246, 0.5)',
                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
                objectFit: 'cover',
                flexShrink: 0,
                display: 'block'
            }}
        />
    </div>
    <div
        className="info"
        style={{
            opacity: isCollapsed && !isHovered ? 0 : 1,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            marginLeft: isCollapsed && !isHovered ? '0' : '12px',
            display: isCollapsed && !isHovered ? 'none' : 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: isCollapsed && !isHovered ? '0' : 'auto',
            overflow: 'hidden'
        }}
    >
        <Link
            to="#"
            className="d-block"
            style={{
                color: 'white',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '0.9rem',
                textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
                whiteSpace: 'nowrap'
            }}
        >
            INVITADO
        </Link>
        <small style={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '0.75rem',
            marginTop: '2px'
        }}>
            🟢 Administrador
        </small>
    </div>
</div>

                    {/* Sidebar Menu */}
                    <nav className="mt-2">
                        <ul
                            className="nav nav-pills nav-sidebar flex-column"
                            data-widget="treeview"
                            role="menu"
                            data-accordion="false"
                            style={{ gap: '4px' }}
                        >
                            

                            
                            {/* Consultas */}
                            <li className={`nav-item ${isConsultasOpen ? 'menu-open' : ''}`}>
                                <Link
                                    to="#"
                                    className="nav-link"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleMenuClick(setConsultasOpen, isConsultasOpen);
                                    }}
                                    title={isCollapsed && !isHovered ? 'Consultas' : ''}
                                    style={{
                                        position: 'relative',
                                        overflow: 'hidden',
                                        borderRadius: '10px',
                                        margin: '4px 0',
                                        background: isConsultasOpen
                                            ? 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(124, 58, 237, 0.2) 100%)'
                                            : 'rgba(255, 255, 255, 0.05)',
                                        border: '1px solid rgba(255, 255, 255, 0.1)',
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        color: 'white',
                                        textDecoration: 'none',
                                        backdropFilter: 'blur(10px)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '12px 16px',
                                        justifyContent: isCollapsed && !isHovered ? 'center' : 'flex-start'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isConsultasOpen) {
                                            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(124, 58, 237, 0.15) 100%)';
                                            e.currentTarget.style.transform = 'translateX(4px)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isConsultasOpen) {
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                            e.currentTarget.style.transform = 'translateX(0)';
                                        }
                                    }}
                                >
                                    <i
                                        className="nav-icon fas fa-search"
                                        style={{
                                            fontSize: isCollapsed && !isHovered ? '1.2rem' : '1.1rem',
                                            color: '#8b5cf6',
                                            textShadow: '0 2px 4px rgba(139, 92, 246, 0.3)',
                                            marginRight: isCollapsed && !isHovered ? '0' : '12px'
                                        }}
                                    ></i>
                                    <p style={{
                                        opacity: isCollapsed && !isHovered ? 0 : 1,
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        marginLeft: isCollapsed && !isHovered ? '-200px' : '0',
                                        fontWeight: '600',
                                        fontSize: '0.9rem',
                                        margin: '0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        flex: 1
                                    }}>
                                        Consultas
                                        <i
                                            className="right fas fa-angle-left"
                                            style={{
                                                transition: 'transform 0.3s ease',
                                                transform: isConsultasOpen ? 'rotate(-90deg)' : 'rotate(0deg)'
                                            }}
                                        ></i>
                                    </p>
                                </Link>
                                <ul className={`nav nav-treeview ${isConsultasOpen && (!isCollapsed || isHovered) ? 'd-block' : 'd-none'}`}
                                    style={{
                                        background: 'rgba(0, 0, 0, 0.2)',
                                        borderRadius: '8px',
                                        margin: '4px 0',
                                        padding: '8px 0',
                                        border: '1px solid rgba(255, 255, 255, 0.05)'
                                    }}
                                >
                                    <li className="nav-item">
                                        <Link to="/invinventario" className="nav-link" title={isCollapsed && !isHovered ? 'Inventario' : ''}
                                            style={{
                                                borderRadius: '8px',
                                                margin: '2px 8px',
                                                transition: 'all 0.3s ease',
                                                color: 'rgba(255, 255, 255, 0.8)',
                                                textDecoration: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '8px 12px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = 'rgba(139, 92, 246, 0.1)';
                                                e.currentTarget.style.color = 'white';
                                                e.currentTarget.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = 'transparent';
                                                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                                                e.currentTarget.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            <i className="fas fa-warehouse nav-icon" style={{ color: '#06b6d4', fontSize: '0.9rem', marginRight: '8px' }}></i>
                                            <p style={{
                                                opacity: isCollapsed && !isHovered ? 0 : 1,
                                                transition: 'opacity 0.3s ease',
                                                margin: '0',
                                                fontSize: '0.85rem'
                                            }}>Inventario</p>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/invsaldos" className="nav-link" title={isCollapsed && !isHovered ? 'Saldos' : ''}
                                            style={{
                                                borderRadius: '8px',
                                                margin: '2px 8px',
                                                transition: 'all 0.3s ease',
                                                color: 'rgba(255, 255, 255, 0.8)',
                                                textDecoration: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '8px 12px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = 'rgba(139, 92, 246, 0.1)';
                                                e.currentTarget.style.color = 'white';
                                                e.currentTarget.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = 'transparent';
                                                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                                                e.currentTarget.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            <i className="fas fa-history nav-icon" style={{ color: '#84cc16', fontSize: '0.9rem', marginRight: '8px' }}></i>
                                            <p style={{
                                                opacity: isCollapsed && !isHovered ? 0 : 1,
                                                transition: 'opacity 0.3s ease',
                                                margin: '0',
                                                fontSize: '0.85rem'
                                            }}>Saldos</p>
                                        </Link>
                                    </li>
                                            

                                    <li className="nav-item">
                                        <Link to="/invconsultor" className="nav-link" title={isCollapsed && !isHovered ? 'Consultor' : ''}
                                            style={{
                                                borderRadius: '8px',
                                                margin: '2px 8px',
                                                transition: 'all 0.3s ease',
                                                color: 'rgba(255, 255, 255, 0.8)',
                                                textDecoration: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '8px 12px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = 'rgba(139, 92, 246, 0.1)';
                                                e.currentTarget.style.color = 'white';
                                                e.currentTarget.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = 'transparent';
                                                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                                                e.currentTarget.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            <i className="nav-icon fas fa-user-tie" style={{ color: '#ec4899', fontSize: '0.9rem', marginRight: '8px' }}></i>
                                            <p style={{
                                                opacity: isCollapsed && !isHovered ? 0 : 1,
                                                transition: 'opacity 0.3s ease',
                                                margin: '0',
                                                fontSize: '0.85rem'
                                            }}>Consultor</p>
                                        </Link>
                                    </li>
                                    
                                </ul>
                            </li>
                        </ul>
                    </nav>

                    {/* Portal Info Panel */}
<div className="portal-panel mt-3 pb-3 mb-3 d-flex" style={{
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    background: 'rgba(59, 130, 246, 0.1)',
    borderRadius: '12px',
    padding: isCollapsed && !isHovered ? '0.8rem 0' : '1rem',
    border: '1px solid rgba(59, 130, 246, 0.3)',
    backdropFilter: 'blur(10px)',
    // Centrar contenido cuando está comprimido
    justifyContent: isCollapsed && !isHovered ? 'center' : 'flex-start',
    alignItems: 'center',
    minHeight: isCollapsed && !isHovered ? '50px' : 'auto',
    width: '100%',
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)'
}}>
    <div className="portal-icon" style={{
        // Centrar el icono cuando está comprimido
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: isCollapsed && !isHovered ? '100%' : 'auto',
        margin: isCollapsed && !isHovered ? '0' : '0'
    }}>
        <i 
            className="fas fa-hdd"
            style={{
                transition: 'all 0.3s ease',
                fontSize: '24px',
                color: '#3b82f6',
                textShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
                flexShrink: 0,
                display: 'block'
            }}
        />
    </div>
    
    <div
        className="portal-info"
        style={{
            opacity: isCollapsed && !isHovered ? 0 : 1,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            marginLeft: isCollapsed && !isHovered ? '0' : '12px',
            display: isCollapsed && !isHovered ? 'none' : 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: isCollapsed && !isHovered ? '0' : 'auto',
            overflow: 'hidden'
        }}
    >
        <span
            style={{
                color: 'white',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '0.9rem',
                textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
                whiteSpace: 'nowrap'
            }}
        >
            🌐 Portal de Usuarios
        </span>
        <small style={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '0.75rem',
            marginTop: '2px'
        }}>
            ✨ TrueNas v3.0
        </small>
    </div>
</div>
                    
                </div>

                
            </aside>

            <style>
                {`
                    /* Estilos para el sidebar moderno */
                    .main-sidebar {
                        scrollbar-width: thin;
                        scrollbar-color: rgba(59, 130, 246, 0.5) rgba(0, 0, 0, 0.2);
                    }
                    
                    .main-sidebar::-webkit-scrollbar {
                        width: 6px;
                    }
                    
                    .main-sidebar::-webkit-scrollbar-track {
                        background: rgba(0, 0, 0, 0.2);
                        border-radius: 3px;
                    }
                    
                    .main-sidebar::-webkit-scrollbar-thumb {
                        background: linear-gradient(180deg, #3b82f6, #1d4ed8);
                        border-radius: 3px;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                    }
                    
                    .main-sidebar::-webkit-scrollbar-thumb:hover {
                        background: linear-gradient(180deg, #2563eb, #1e40af);
                    }
                    
                    /* Tooltips modernos para modo contraído */
                    .nav-link[title]:hover::after {
                        content: attr(title);
                        position: absolute;
                        left: calc(100% + 15px);
                        top: 50%;
                        transform: translateY(-50%);
                        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
                        color: white;
                        padding: 8px 12px;
                        border-radius: 8px;
                        white-space: nowrap;
                        z-index: 1000;
                        font-size: 12px;
                        font-weight: 600;
                        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3), 0 4px 10px rgba(0, 0, 0, 0.2);
                        border: 1px solid rgba(59, 130, 246, 0.3);
                        opacity: 0;
                        animation: modernTooltipFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
                        backdrop-filter: blur(10px);
                    }
                    
                    .nav-link[title]:hover::before {
                        content: '';
                        position: absolute;
                        left: calc(100% + 8px);
                        top: 50%;
                        transform: translateY(-50%);
                        width: 0;
                        height: 0;
                        border-style: solid;
                        border-width: 6px 7px 6px 0;
                        border-color: transparent #1f2937 transparent transparent;
                        z-index: 1001;
                        opacity: 0;
                        animation: modernTooltipFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
                    }
                    
                    @keyframes modernTooltipFadeIn {
                        from {
                            opacity: 0;
                            transform: translateY(-50%) translateX(-10px) scale(0.9);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(-50%) translateX(0) scale(1);
                        }
                    }
                    
                    /* Ocultar tooltips cuando el sidebar está expandido */
                    .main-sidebar:not([style*="width: 70px"]) .nav-link[title]:hover::after,
                    .main-sidebar:not([style*="width: 70px"]) .nav-link[title]:hover::before {
                        display: none;
                    }
                    
                    /* Efectos de hover mejorados */
                    .nav-link:hover {
                        backdrop-filter: blur(10px);
                    }
                    
                    /* Animaciones suaves para los menús desplegables */
                    .nav-treeview {
                        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    }
                    
                    /* Responsive para pantallas pequeñas */
                    @media (max-width: 768px) {
                        .content-wrapper,
                        .main-header {
                            margin-left: 0 !important;
                        }
                        
                        .main-sidebar {
                            transform: translateX(-100%);
                            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                        }
                        
                        .main-sidebar:hover {
                            transform: translateX(0);
                        }
                    }
                    
                    /* Efectos de glassmorphism */
                    .user-panel {
                        backdrop-filter: blur(20px);
                        -webkit-backdrop-filter: blur(20px);
                    }
                    
                    .nav-treeview {
                        backdrop-filter: blur(10px);
                        -webkit-backdrop-filter: blur(10px);
                    }
                    
                    /* Mejoras en las transiciones */
                    * {
                        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                    }
                    
                    /* Estilos adicionales para el botón toggle */
                    .main-sidebar button:focus {
                        outline: none;
                        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
                    }
                    
                    /* Mejoras en la accesibilidad */
                    .nav-link:focus {
                        outline: 2px solid rgba(59, 130, 246, 0.5);
                        outline-offset: 2px;
                    }
                    
                    /* Animaciones para el toggle del sidebar */
                    .main-sidebar {
                        will-change: width;
                    }
                    
                    /* Optimizaciones de rendimiento */
                    .nav-link,
                    .nav-treeview,
                    .user-panel {
                        will-change: transform, opacity;
                    }
                    
                    /* Estilos para modo oscuro mejorado */
                    .main-sidebar .brand-link:hover {
                        background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
                    }
                    
                    /* Efectos de profundidad */
                    .nav-item.menu-open > .nav-link {
                        box-shadow: inset 4px 0 0 rgba(59, 130, 246, 0.8);
                    }
                    
                    /* Indicadores visuales mejorados */
                    .nav-link.active {
                        background: linear-gradient(135deg, rgba(59, 130, 246, 0.3) 0%, rgba(29, 78, 216, 0.3) 100%) !important;
                    border-left: 4px solid #3b82f6;
                }

                /* Mejoras en la navegación por teclado */
                .nav-link:focus-visible {
                    outline: 2px solid #3b82f6;
                    outline-offset: 2px;
                    border-radius: 8px;
                }

                /* Animaciones de entrada para los elementos del menú */
                .nav-item {
                    animation: slideInFromLeft 0.3s ease-out;
                }

                @keyframes slideInFromLeft {
                    from {
                        opacity: 0;
                        transform: translateX(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }

                /* Efectos de pulsación para botones */
                .main-sidebar button:active {
                    transform: scale(0.95);
                }

                /* Mejoras en la legibilidad */
                .nav-link p {
                    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
                }

                /* Estilos para estados de carga */
                .nav-link.loading {
                    opacity: 0.6;
                    pointer-events: none;
                }

                /* Indicadores de notificación */
                .nav-link .badge {
                    position: absolute;
                    top: 8px;
                    right: 8px;
                    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
                    color: white;
                    border-radius: 50%;
                    width: 18px;
                    height: 18px;
                    font-size: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 600;
                    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
                }

                /* Mejoras en la accesibilidad para lectores de pantalla */
                .sr-only {
                    position: absolute;
                    width: 1px;
                    height: 1px;
                    padding: 0;
                    margin: -1px;
                    overflow: hidden;
                    clip: rect(0, 0, 0, 0);
                    white-space: nowrap;
                    border: 0;
                }

                /* Estilos para modo de alto contraste */
                @media (prefers-contrast: high) {
                    .main-sidebar {
                        border-right: 2px solid #ffffff;
                    }
                    
                    .nav-link {
                        border: 1px solid rgba(255, 255, 255, 0.3);
                    }
                }

                /* Estilos para reducir movimiento */
                @media (prefers-reduced-motion: reduce) {
                    .main-sidebar,
                    .nav-link,
                    .nav-treeview,
                    .user-panel,
                    * {
                        transition: none !important;
                        animation: none !important;
                    }
                }

                /* Optimizaciones para dispositivos táctiles */
                @media (hover: none) and (pointer: coarse) {
                    .nav-link {
                        min-height: 44px;
                        padding: 12px 16px;
                    }
                    
                    .nav-link[title]:hover::after,
                    .nav-link[title]:hover::before {
                        display: none;
                    }
                }

                /* Estilos para impresión */
                @media print {
                    .main-sidebar {
                        display: none;
                    }
                }

                /* Mejoras en el contraste de colores */
                .nav-link:hover,
                .nav-link:focus {
                    color: #ffffff !important;
                }

                /* Estilos para el estado activo de la página actual */
                .nav-link[aria-current="page"] {
                    background: linear-gradient(135deg, rgba(59, 130, 246, 0.4) 0%, rgba(29, 78, 216, 0.4) 100%) !important;
                    border-left: 4px solid #3b82f6;
                    font-weight: 700;
                }

                /* Mejoras en la jerarquía visual */
                .nav-treeview .nav-link {
                    font-size: 0.8rem;
                    padding-left: 2rem;
                }

                /* Efectos de profundidad mejorados */
                .main-sidebar::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: linear-gradient(180deg, rgba(59, 130, 246, 0.05) 0%, transparent 100%);
                    pointer-events: none;
                    z-index: -1;
                }

                /* Estilos para el estado de carga del sidebar */
                .main-sidebar.loading {
                    opacity: 0.8;
                }

                .main-sidebar.loading::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
                    animation: shimmer 1.5s infinite;
                }

                @keyframes shimmer {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
                `}
            </style>
            
        </>
    );
};

export default Sidebar;